module.exports = __webpack_public_path__ + "img/4888c63.png";